export const CLUSTERS = "clusters";

module.exports = {
  CLUSTERS
};
